// Cada empreendimento tem uma logo com o seu próprio fundo (branco, escuro,
// colorido). Em vez de configurar isso mapa a mapa, lemos a cor direto da
// imagem: a moda das bordas é o fundo dela em praticamente todo logo chapado.
const OPAQUE = 128;
// Agrupa tons quase idênticos — JPEG não devolve o branco exato em toda borda.
const BUCKET = 3;
// Abaixo disso a borda não tem uma cor dominante: provavelmente não é fundo
// chapado (logo recortada, gradiente), então é melhor não mexer.
const MIN_SHARE = 0.5;

export default function sampleLogoBackground(image) {
  const width = image.naturalWidth;
  const height = image.naturalHeight;
  if (!width || !height) return null;

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(image, 0, 0);

  let data;
  try {
    data = canvas.getContext("2d").getImageData(0, 0, width, height).data;
  } catch (error) {
    // Logo servida de outra origem deixa o canvas inacessível.
    return null;
  }

  const counts = new Map();
  const tally = (x, y) => {
    const offset = (y * width + x) * 4;
    // Borda transparente não é fundo chapado.
    if (data[offset + 3] < OPAQUE) return;

    const key = `${data[offset] >> BUCKET}|${data[offset + 1] >> BUCKET}|${
      data[offset + 2] >> BUCKET
    }`;
    const found = counts.get(key);
    if (found) {
      found.total += 1;
      return;
    }
    counts.set(key, {
      total: 1,
      color: `rgb(${data[offset]}, ${data[offset + 1]}, ${data[offset + 2]})`,
    });
  };

  for (let x = 0; x < width; x += 1) {
    tally(x, 0);
    tally(x, height - 1);
  }
  for (let y = 0; y < height; y += 1) {
    tally(0, y);
    tally(width - 1, y);
  }

  let dominant = null;
  counts.forEach((entry) => {
    if (!dominant || entry.total > dominant.total) dominant = entry;
  });

  const perimeter = 2 * (width + height);
  if (!dominant || dominant.total < perimeter * MIN_SHARE) return null;

  return dominant.color;
}
